import instance from 'utils/axios/instance.axios';
import { PROGRAMS } from './_constant';

export const getAll = () => instance.get(PROGRAMS.GET_ALL);

export const getAllByFilter = (pagination, filters) =>
  instance.get(PROGRAMS.GET_ALL_BY_FILTER, {
    params: {
      ...pagination,
      ...filters,
    },
  });

export const create = (data = {}) => instance.post(PROGRAMS.CREATE, data);

export const update = ({ id, data }) => instance.patch(PROGRAMS.UPDATE(id), data);

export const deleteById = (id) => instance.delete(PROGRAMS.DELETE(id));

export const setUnitPreQualificationDeadline = ({ programId, data = {} }) =>
  instance.post(PROGRAMS.SET_UNIT_PRE_QUALIFICATION_DEADLINES(programId), data);

export const getUnitPreQualificationDeadlines = (programId) =>
  instance.get(PROGRAMS.GET_UNIT_PRE_QUALIFICATION_DEADLINES(programId));
